import { useCallback } from 'react';
import type { FolderDetailCategory } from 'shared/src/api/likedFolderService/getFolderDetailCategories';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';
import { ALL_CATEGORY, type FolderType } from '../constants';

export const useLogApplyCategoryChipFilter = (folderType: FolderType) => {
  const logAnalyticsEvent = useLogAnalyticsEvent();
  return useCallback(
    (category?: FolderDetailCategory | null) => {
      const target = category ?? ALL_CATEGORY;
      logAnalyticsEvent({
        name: 'APPLY_CATEGORY_CHIP_FILTER',
        analytics: {
          CATEGORY_SNO: target.sno.toString(),
          CATEGORY_NAME: target.name,
          FOLDER_TYPE: folderType,
        },
      });
    },
    [logAnalyticsEvent, folderType],
  );
};
